<template>
  <Modal v-if="visible" :value="true" @input="closeModal" width="xl">
    <span slot="header">Cadastro de Login e Senha por Prefeitura</span>
    
    <div class="row">
      <div class="col-md-5">
        <div class="ibox">
          <div class="ibox-title">
            <h4 v-if="currentCityLogin.id">Atualizar Login e Senha</h4>
            <h4 v-else>Salvar Login e Senha</h4>
          </div>
          
          <div class="ibox-content">
            <!-- Faker -->
            <input id="username" style="display:none" type="text" name="fakeusernameremembered">
            <input id="password" style="display:none" type="password" name="fakepasswordremembered">
            
            <div class="form-group">
              <label for="city-login-code">Cidade</label>
              <select v-model="currentCityLogin.code" class="form-control" id="city-login-code">
                <option v-for="[key, label] in cityCodes" :key="key" :value="key">
                  {{ label }}
                </option>
              </select>
            </div>
            
            <div class="form-group">
              <label for="city-login-login">Login</label>
              <input v-model="currentCityLogin.login" class="form-control" id="city-login-login" autocomplete="off">
            </div>
            
            <div class="form-group" style="position: relative">
              <label for="city-login-password">Senha</label>
              <input v-model="currentCityLogin.password" class="form-control"
                     autocomplete="new-password"
                     :type="showPassword ? 'text' : 'password'"
                     id="city-login-password">
              <i class="eye-password" @click="showPassword = !showPassword"
                 :title="showPassword ? 'Ocultar Senha' : 'Mostrar Senha'">
                <EyeIcon v-if="showPassword" />
                <EyeOffIcon v-else/>
              </i>
            </div>
  
            <div class="form-group">
              <template v-if="currentCityLogin.id">
                <button class="col-sm-4 btn btn-success" @click="save">
                  {{ 'btn.save' | t }}
                </button>
                <button class="col-sm-4 btn btn-outline" @click="cancel">
                  {{ 'btn.cancel' | t }}
                </button>
                <button class="col-sm-4 btn btn-outline-red" @click="sendDelete(currentCityLogin)">
                  {{ 'btn.delete' | t }}
                </button>
              </template>
              
              <template v-else>
                <button class="btn btn-primary form-control" @click="save">
                  {{ 'btn.save' | t }}
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-7">
        <div class="ibox">
          
          <div class="ibox-title">
            <h4>Cadastros</h4>
          </div>
  
          <div v-if="!fetchModels" class="ibox-content">
            <h4 class="text-align-center">Carregando...</h4>
          </div>
          
          <div v-else-if="cityLogins.length === 0" class="ibox-content">
            <h4 class="text-align-center">Nenhum login cadastrado</h4>
          </div>
  
          <div v-else class="ibox-content">
            <table class="table table-borderless table-border table-align">
              <thead>
              <tr>
                <th>Cidade</th>
                <th>Login</th>
                <th>Senha</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="cityLogin in cityLogins" :key="cityLogin.id">
                <td>{{ descriptionByCode(cityLogin.code) }}</td>
                <td>{{ cityLogin.login }}</td>
                <td><strong>******</strong></td>
                <td>
                  <button class="btn btn-outline mr-2" @click="edit(cityLogin)">
                    {{ 'btn.edit' | t }}
                  </button>
                  <button class="btn btn-outline-red" @click="sendDelete(cityLogin)">
                    {{ 'btn.delete' | t }}
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
  import Modal from '@/components/shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
  import { EyeIcon, EyeOffIcon } from 'vue-feather-icons'
  
  export default {
    components: { EyeIcon, EyeOffIcon, Modal },
    computed: {
      cityLogins() {
        return this.models || []
      },
      visible() {
        return this.value
      }
    },
    created() {
      this.$set(this.query, 'companyId', this.companyId)
      this.asyncTemplateSelect({
        after: () => this.fetchModels = true
      })
    },
    data() {
      return {
        cityCodes: [
          ['3501806', 'Américo de Campos - SP'], ['2101202', 'Bacabal - MA'], ['3505203', 'Bariri - SP'], ['5101803', 'Barra do Garças - MT'], ['3106200', 'Belo Horizonte - MG'], ['5002209', 'Bonito - MS'], ['5101902', 'Brasnorte - MT'], ['3507803', 'Brodowski - SP'], ['3504800', 'Bálsamo - SP'], ['3509502', 'Campinas - SP'], ['5002704', 'Campo Grande - MS'], ['3114402', 'Carmo do Rio Claro - MG'], ['3511300', 'Cedral - SP'], ['3118601', 'Contagem - MG'], ['5003207', 'Corumbá - MS'], ['3512902', 'Cosmorama - SP'], ['3514403', 'Dracena - SP'], ['3514502', 'Duartina - SP'], ['4108304', 'Foz do Iguaçu - PR'], ['3516705', 'Garça - SP'], ['5208707', 'Goiânia - GO'], ['3518206', 'Guararapes - SP'], ['3517406', 'Guaíra - SP'], ['5209705', 'Hidrolândia - GO'], ['3519303', 'Ibaté - SP'], ['3519600', 'Ibitinga - SP'], ['3520103', 'Igarapava - SP'], ['1503606', 'Itaituba - PA'], ['5104807', 'Jaciara - MT'], ['5005004', 'Jardim - MS'], ['1100114', 'Jaru - RO'], ['1100122', 'Ji-Paraná - RO'], ['3136702', 'Juiz de Fora - MG'], ['4113700', 'Londrina - PR'], ['4311809', 'Marau - RS'], ['5105622', 'Mirassol D\'Oeste - MT'], ['3143401', 'Monte Sião - MG'], ['3532009', 'Morungaba - SP'], ['3533502', 'Novo Horizonte - SP'], ['1100155', 'Ouro Preto do Oeste - RO'], ['3303807', 'Paraty - RJ'], ['3537107', 'Pedreira - SP'], ['2108207', 'Pedreiras - MA'], ['3538907', 'Pirajuí - SP'], ['3539004', 'Pirangi - SP'], ['3540200', 'Pontal - SP'], ['3541604', 'Promissão - SP'], ['1200401', 'Rio Branco - AC'], ['1506161', 'Rio Maria - PA'], ['3544004', 'Rio das Pedras - SP'], ['2927408', 'Salvador - BA'], ['3547700', 'Santo Anastácio - SP'], ['3548005', 'Santo Antônio de Posse - SP'], ['3205002', 'Serra - ES'], ['3551405', 'Serra Azul - SP'], ['3551603', 'Serra Negra - SP'], ['3549409', 'São Joaquim da Barra - SP'], ['5008305', 'Três Lagoas - MS'], ['3170701', 'Varginha - MG'], ['1508407', 'Xinguara - PA']
        ],
        currentCityLogin: { code: '', companyId: this.companyId, login: '', password: '' },
        fetchModels: false,
        modelPathPrefix: 'dfe',
        nameModel: 'CityLogin',
        showPassword: false
      }
    },
    methods: {
      cancel() {
        this.currentCityLogin = { companyId: this.companyId }
      },
      closeModal() {
        this.$emit('input', false)
      },
      deleteCityLogin(cityLogin) {
        this.asyncTemplateDelete(cityLogin, {
          after: () => {
            this.currentCityLogin = { companyId: this.companyId }
            this.$notify.add('Login e Senha apagado!')
            this.find()
          }
        })
      },
      descriptionByCode(code) {
        const list = this.cityCodes.find(([cityCode]) => cityCode === code)
        return list ? list[1] : ''
      },
      edit(cityLogin) {
        this.currentCityLogin = cityLogin
      },
      find() {
        this.asyncTemplateSelect()
      },
      save() {
        this.asyncTemplateSave(this.currentCityLogin, {
          after: () => {
            this.currentCityLogin = { companyId: this.companyId }
            this.$notify.add('Login e Senha salvo.')
            this.find()
          }
        })
      },
      sendDelete(cityLogin) {
        if (!confirm('Tem certeza?'))
          return
        
        this.deleteCityLogin(cityLogin)
      }
    },
    mixins: [ModelMapper],
    name: 'ModalCityLogin',
    props: {
      companyId: { required: true, type: Number},
      value: { require: true }
    }
  }
</script>

<style scoped>
 .eye-password {
   cursor: pointer;
   position: absolute;
   right: 4px;
   bottom: 4px;
 }
</style>
